import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import api from "../lib/api";
import { vibrantTheme } from "./common";
import { AirportCard } from "./PopularAirports";

/* "Top airports in {country}" — curated passenger-ranked list on country profile pages. */
export default function CountryTopAirports({ countryName, countryCode }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!countryName) return;
    api.get("/airports-popular/country", { params: { name: countryName, code: countryCode } })
      .then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [countryName, countryCode]);

  if (!items || items.length === 0) return null;
  const theme = vibrantTheme(`country-top-${countryName}`);

  return (
    <div className="mb-10" data-testid="country-top-airports">
      <h2 className="font-heading font-900 text-2xl mb-1 flex items-center gap-2" style={{ color: theme.bg }}>
        <Trophy className="w-6 h-6" /> Top airports in {countryName}
      </h2>
      <p className="text-base text-zinc-600 mb-4">Ranked by annual passenger traffic.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((a) => <AirportCard key={a.iata} a={{ ...a, role: a.tag }} accent={theme.bg} />)}
      </div>
    </div>
  );
}
